/** Variáveis disponíveis para interpolação nos campos do fluxo (sintaxe tipo mustache). */

export const WORKFLOW_FLOW_VARIABLE_GROUPS = [
  {
    id: 'conversation',
    label: 'Conversa',
    hint:
      'Campos da conversa atual quando o fluxo corre (substituição no servidor quando suportado).',
    variables: [
      { label: 'ID interno', token: '{{conversation.id}}' },
      { label: 'Display ID', token: '{{conversation.display_id}}' },
      { label: 'UUID', token: '{{conversation.uuid}}' },
      { label: 'Status', token: '{{conversation.status}}' },
      { label: 'Prioridade', token: '{{conversation.priority}}' },
      { label: 'ID da inbox', token: '{{conversation.inbox_id}}' },
      { label: 'ID do contacto', token: '{{conversation.contact_id}}' },
      { label: 'ID do agente atribuído', token: '{{conversation.assignee_id}}' },
      { label: 'ID do time', token: '{{conversation.team_id}}' },
      { label: 'Atributos (JSON)', token: '{{conversation.custom_attributes_json}}' },
    ],
  },
  {
    id: 'contact',
    label: 'Contacto',
    hint: 'Dados do contacto associado à conversa.',
    variables: [
      { label: 'ID', token: '{{contact.id}}' },
      { label: 'Nome', token: '{{contact.name}}' },
      { label: 'Email', token: '{{contact.email}}' },
      { label: 'Telefone', token: '{{contact.phone_number}}' },
      { label: 'Identificador', token: '{{contact.identifier}}' },
      { label: 'Atributos (JSON)', token: '{{contact.custom_attributes_json}}' },
    ],
  },
  {
    id: 'message',
    label: 'Mensagem',
    hint:
      'Disponível quando o fluxo é disparado por «Mensagem recebida» (ou quando o executor definir o contexto da mensagem).',
    variables: [
      { label: 'ID', token: '{{message.id}}' },
      { label: 'Conteúdo', token: '{{message.content}}' },
      { label: 'Tipo', token: '{{message.message_type}}' },
      { label: 'ID da inbox', token: '{{message.inbox_id}}' },
      { label: 'ID da conversa', token: '{{message.conversation_id}}' },
      { label: 'É privada?', token: '{{message.private}}' },
    ],
  },
  {
    id: 'workflow',
    label: 'Fluxo',
    variables: [
      { label: 'ID do fluxo', token: '{{workflow.id}}' },
      { label: 'Nome do fluxo', token: '{{workflow.name}}' },
    ],
  },
  {
    id: 'account',
    label: 'Conta',
    variables: [
      { label: 'ID da conta', token: '{{account.id}}' },
      { label: 'Nome da conta', token: '{{account.name}}' },
    ],
  },
  {
    id: 'upstream',
    label: 'Nó anterior',
    hint:
      'Valores produzidos pelo nó que corre antes deste (ex.: resposta HTTP). O executor pode expor estes campos no futuro.',
    variables: [
      {
        label: 'Corpo da última resposta HTTP',
        token: '{{upstream.http_response.body}}',
      },
      {
        label: 'Código da última resposta HTTP',
        token: '{{upstream.http_response.status_code}}',
      },
      {
        label: 'Cabeçalhos da última resposta (JSON)',
        token: '{{upstream.http_response.headers_json}}',
      },
    ],
  },
  {
    id: 'kanban_item',
    label: 'Cartão Kanban',
    hint:
      'Preenchido quando o fluxo dispara por um evento do Kanban ligado à conversa, ou pelo cartão associado ao display_id da conversa.',
    variables: [
      { label: 'ID do cartão', token: '{{kanban_item.id}}' },
      { label: 'ID do funil', token: '{{kanban_item.funnel_id}}' },
      { label: 'Etapa (chave)', token: '{{kanban_item.funnel_stage}}' },
      { label: 'Título', token: '{{kanban_item.title}}' },
      { label: 'Status (won/lost/open)', token: '{{kanban_item.status}}' },
      { label: 'Prioridade', token: '{{kanban_item.priority}}' },
      { label: 'Valor', token: '{{kanban_item.value}}' },
      {
        label: 'Display ID da conversa ligada',
        token: '{{kanban_item.conversation_display_id}}',
      },
    ],
  },
];

export const WORKFLOW_VARIABLE_DRAG_TYPE = 'application/x-chatwoot-workflow-var';
